/* eslint-disable */
export default function truncateString(str, num) {
    if (!str) return str;
    
    if (str.length > num) {
        return str.slice(0, num) + "...";
    } else {
        return str;
    }
}